import React from 'react';
import { Container } from 'react-bootstrap';

function PrivacyPolicy() {
    return (
        <Container className="text-white py-5" style={{ minHeight: '80vh' }}>
            <h1 className="fw-bold mb-4">Privacy Policy</h1>
            <p>Last Updated: {new Date().toLocaleDateString()}</p>

            <section className="mb-4">
                <h2>1. Introduction</h2>
                <p>
                    Qcoda LLC ("we," "us," or "our") respects your privacy and is committed to protecting your personal data.
                    This privacy policy will inform you as to how we look after your personal data when you visit our website
                    and tell you about your privacy rights and how the law protects you.
                </p>
            </section>

            <section className="mb-4">
                <h2>2. Data We Collect</h2>
                <p>
                    We may collect, use, store, and transfer different kinds of personal data about you which we have grouped together follows:
                </p>
                <ul>
                    <li><strong>Identity Data:</strong> includes first name, last name, username or similar identifier.</li>
                    <li><strong>Contact Data:</strong> includes email address and telephone number.</li>
                    <li><strong>Technical Data:</strong> includes internet protocol (IP) address, your login data, browser type and version, time zone setting and location, and other technology on the devices you use to access this website.</li>
                    <li><strong>Usage Data:</strong> includes information about how you use our website, products, and services.</li>
                </ul>
            </section>

            <section className="mb-4">
                <h2>3. How We Use Your Data</h2>
                <p>
                    We will only use your personal data when the law allows us to. Most commonly, we will use your personal data in the following circumstances:
                </p>
                <ul>
                    <li>To provide and maintain our Service.</li>
                    <li>To notify you about changes to our Service.</li>
                    <li>To provide customer support.</li>
                    <li>To gather analysis or valuable information so that we can improve the Service.</li>
                    <li>To monitor the usage of the Service.</li>
                </ul>
            </section>

            <section className="mb-4">
                <h2>4. Data Sharing</h2>
                <p>
                    We do not sell your personal data to third parties. We may share your data with third-party service providers
                    to help us operate our business and the Site or administer activities on our behalf, such as sending out newsletters or surveys.
                </p>
            </section>

            <section className="mb-4">
                <h2>5. Data Security</h2>
                <p>
                    We have put in place appropriate security measures to prevent your personal data from being accidentally lost,
                    used or accessed in an unauthorized way, altered or disclosed.
                </p>
            </section>

            <section className="mb-4">
                <h2>6. Your Legal Rights</h2>
                <p>
                    Under certain circumstances, you have rights under data protection laws in relation to your personal data,
                    including the right to request access, correction, erasure, restriction, transfer, to object to processing,
                    to portability of data and (where the lawful ground of processing is consent) to withdraw consent.
                </p>
            </section>

            <section className="mb-4">
                <h2>7. Contact Us</h2>
                <p>
                    If you have any questions about this privacy policy or our privacy practices, please contact us.
                </p>
            </section>
        </Container>
    );
}

export default PrivacyPolicy;
